import { Component, ElementRef, HostListener, inject, OnInit, ViewChild } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { CommonService } from './_common/_service/user.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
 
})
export class AppComponent implements OnInit {
  title = 'Zenithguard.in';
  userActivity: any;

  userInactive: Subject<any> = new Subject();
  cookieValue: string = '';
 
  constructor(private _service: CommonService, private location: LocationStrategy
  ) {

    // preventing back button in browser 
    history.pushState(null, "null", window.location.href);
    this.location.onPopState(() => {
      history.pushState(null, "null", window.location.href);
    });
    this.setTimeout();
    this.userInactive.subscribe(() => console.log('user has been inactive'));
}

  ngOnInit(): void {
    history.pushState(null, '', location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  }

  setTimeout() {
    this.userActivity = setTimeout(() => this.userInactive.next(this._service.callMethodOfSecondComponent()), 12000000);
  }

  @HostListener('window:keydown') refreshUserState() {
    clearTimeout(this.userActivity);
    this.setTimeout();
  }
  @HostListener('window:mousemove') refreshUserState1() {
    clearTimeout(this.userActivity);
    this.setTimeout();
  }
  @HostListener('window:touchstart') refreshUserState2() {
    clearTimeout(this.userActivity);
    this.setTimeout();
  }
  
}
